<template>
  <v-app>
    <div
      id="wrapper"
      :class="{ 'mini-navbar': !isMaximized }"
    >
      <navbar
        v-if="getUser.apitoken && !showNavs"
        :facility-nav-menu="facilityNavMenu"
        :show-navs="showNavs"
        :change-active-nav="changeActiveNav"
        :is-maximized="isMaximized"
        :facility-logo="facilityLogo"
        :facility-logo-small="facilityLogoSmall"
        :facilities="filteredUserFacilities"
        :change-facility="changeFacility"
        :mini="mini"
        :profile-img="profileImg"
        :small-logo="smallLogo"
        :large-logo="largeLogo"
        :userId="getUser.user_id"
        ref="navbar"
        @nav-change="handleNavChange"
      />

      <div
        id="page-wrapper"
        class="d-flex flex-column vh100"
        v-bind:class="{
          pageWrapperBgColor: true,
          'full-screen': showNavs,
          'gray-bg': !showNavs,
          'enable-transition': enableTransition,
          'background-401': on401Page,
        }"
        :style="isLogin"
        @click="closeNavbar"
      >
        <v-overlay
          :absolute="true"
          :value="secondaryDrawerStatus"
          :z-index="3"
        ></v-overlay>
        <div v-if="getUser.apitoken">
          <nav
            class="navbar navbar-static-top"
            :class="{
              'theme--dark': userData.theme === 'dark',
              'white-bg': userData.theme === 'light',
            }"
            role="navigation"
            style="width: 100%; margin-bottom: 8px"
            v-show="!showNavs"
          >
            <v-row no-gutters>
              <v-col
                cols="2"
                md="4"
                sm="4"
                class="pt-2 pb-2"
              >
                <div
                  style="margin-left: 10px; float: left; padding-right: 10px"
                  class="mainMenuOpenCloseBtn"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="primary"
                        small
                        mt-2
                        v-on:click="setMaximized($event)"
                      >
                        <v-icon
                          size="large"
                          v-on="on"
                          >menu</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>Show/Hide Menu</span>
                  </v-tooltip>
                </div>

                <div
                  v-if="branding && branding.productName"
                  class="d-none d-sm-flex d-md-none"
                  style="
                    padding-top: 5px;
                    font-weight: bold;
                    height: 30px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    font-family: 'Poppins', sans-serif;
                  "
                >
                  <img
                    :src="branding.favIconUrl"
                    style="width: 20px; height: 20px; margin-right: 3px"
                  />
                  {{ branding.productName }}
                </div>
              </v-col>

              <v-col
                cols="10"
                md="8"
                sm="8"
                style="text-align: right"
                class="pt-2 pb-2"
              >
                <v-menu
                  v-show="isMaximized"
                  offset-y
                  dense
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      color="primary"
                      small
                      class="hidden-md-and-up truncateFacilityNameTopMenu"
                      style="width: 120px; margin-top: 0px; margin-right: 10px; margin-left: 0px"
                      >{{ getUser.facilityname }}</v-btn
                    >
                  </template>

                  <v-list dense>
                    <v-list-item
                      dense
                      v-for="facility in filteredUserFacilities"
                      :key="facility.id"
                      v-on:click="changeFacility(facility.facility_id)"
                    >
                      <v-list-item-title>{{ facility.facility }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <span class="nav-item">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        small
                        icon
                        @click="setIsViewingHelp(true)"
                        color="primary"
                        v-on="on"
                        class="mr-1"
                      >
                        <v-icon>help</v-icon>
                      </v-btn>
                    </template>
                    <span>View Help</span>
                  </v-tooltip>
                </span>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      small
                      color="primary"
                      class="mr-1"
                      v-on="on"
                      @click="showLargeMenu = true"
                    >
                      <v-icon>widgets</v-icon>
                    </v-btn>
                  </template>
                  <span>Menu</span>
                </v-tooltip>

                <span class="nav-item hidden-sm-and-down">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        small
                        color="primary"
                        class="mr-1"
                        v-on="on"
                        @click="onShowPresentation"
                      >
                        <v-icon>present_to_all</v-icon>
                      </v-btn>
                    </template>
                    <span>Start Presentation Mode</span>
                  </v-tooltip>
                </span>

                <span class="nav-item">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        small
                        color="primary"
                        class="mr-1"
                        v-on="on"
                        @click="onShowNewsletterPopup"
                      >
                        <v-icon>info</v-icon>
                      </v-btn>
                    </template>
                    <span>Facility Status Report</span>
                  </v-tooltip>
                </span>

                <span class="nav-item hidden-sm-and-down">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        small
                        color="primary"
                        class="mr-1"
                        v-on="on"
                        @click="onDisplayReleaseNotes"
                      >
                        <v-icon v-on="on">new_releases</v-icon>
                      </v-btn>
                    </template>
                    <span>View release notes</span>
                  </v-tooltip>
                </span>

                <span class="hidden-sm-and-down">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        small
                        color="primary"
                        class="mr-1"
                        v-on="on"
                        @click="onAddNewTicket"
                      >
                        <v-icon>bug_report</v-icon>
                      </v-btn>
                    </template>
                    <span>Report a problem or suggestion at your facility</span>
                  </v-tooltip>
                </span>

                <span class="hidden-sm-and-down">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        small
                        color="primary"
                        class="mr-1"
                        v-on="on"
                        @click="onAddNewRepairTicket"
                      >
                        <v-icon>report</v-icon>
                      </v-btn>
                    </template>
                    <span>Create a repair ticket at your facility</span>
                  </v-tooltip>
                </span>

                <span>
                  <v-tooltip
                    v-if="isConnected"
                    bottom
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        class="icon-pointer"
                        v-on="on"
                        color="success"
                        >mdi-circle-slice-8</v-icon
                      >
                    </template>
                    <span>Websocket Connected</span>
                  </v-tooltip>

                  <v-tooltip
                    v-else
                    bottom
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        class="icon-pointer"
                        v-on="on"
                        color="error"
                        >mdi-circle-slice-8</v-icon
                      >
                    </template>
                    <span>Websocket Disconnected</span>
                  </v-tooltip>

                  <chat
                    :show="showChat"
                    @closed="showChat = false"
                    ref="chat"
                  />
                </span>

                <span class="hidden-md-and-down nav-item clock">{{ topClock }}&nbsp;{{ topClockTimeZone }}</span>

                <span class="hidden-lg-and-up hidden-sm-and-down nav-item clock">{{ topClock }}</span>
                <span class="hidden-lg-and-up hidden-sm-and-down nav-item clock">{{ topClockTimeZone }}</span>

                <template v-if="isAuthenticated">
                  <span
                    style="padding-right: 5px"
                    class="hidden-sm-and-down"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          text
                          @click="doLogout"
                          color="primary"
                          v-on="on"
                        >
                          <v-icon left>exit_to_app</v-icon>
                          <span>Logout</span>
                        </v-btn>
                      </template>
                      <span>Logout</span>
                    </v-tooltip>
                  </span>

                  <span
                    style="padding-right: 5px"
                    class="hidden-md-and-up"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          text
                          @click="doLogout"
                          color="primary"
                          v-on="on"
                          >exit_to_app</v-icon
                        >
                      </template>
                      <span>Logout</span>
                    </v-tooltip>
                  </span>
                </template>
              </v-col>
            </v-row>
          </nav>

          <v-dialog
            v-model="showFacilityStatus"
            width="500"
            eager
          >
            <facility-status
              context="popup"
              ref="facilityStatus"
              :active="showFacilityStatus"
            />
          </v-dialog>

          <v-dialog
            v-model="showNewsletter"
            width="750"
            eager
            persistent
          >
            <facility-newsletter
              class="vh90"
              v-if="showNewsletter && getUser.facility_id"
              :facility-id="getUser.facility_id"
              :showFakeNewsletter="showFakeNewsletter"
              @close="showNewsletter = false"
            />
          </v-dialog>

          <v-dialog
            v-model="showSla"
            v-if="showSla"
            width="800"
            persistent
            class="vh90"
          >
            <service-level-agreement-viewer
              v-model="currentSla"
              :showButton="true"
              @close="showSla = false"
            />
          </v-dialog>

          <v-dialog
            v-model="showReleaseNotes"
            v-if="showReleaseNotes"
            width="900"
            persistent
          >
            <release-notes-viewer
              @close="showReleaseNotes = false"
              class="vh90"
            />
          </v-dialog>
        </div>

        <!-- main container -->
        <div class="d-flex flex-column flex-grow-auto overflow-auto h-100">
          <div
            class="flex-grow-1"
            style="position: relative"
            v-bind:class="[showNavs ? 'noAppHeight' : '']"
          >
            <div
              v-show="showServiceInterruptOverlay"
              class="serviceInterruptOverlay"
              ref="serviceInterruptOverlay"
              @scroll="handelOverlayScroll"
            ></div>
            <router-view
              :branding="branding"
              v-if="branding"
            />
          </div>

          <div
            class="footer"
            :class="{
              'theme--dark': userData.theme === 'dark',
              'd-none': hideFooter,
            }"
            style="height: 40px; font-size: 13px"
            v-if="!showNavs"
          >
            {{ $t('footer.copyright') }}
            <span class="copyright">&copy;</span>
            {{ copyrightNotice }}
          </div>
        </div>
      </div>

      <v-dialog
        v-model="showCreateRepairTicket"
        width="800"
        persistent
      >
        <CreateNewRepairTicket
          v-if="showCreateRepairTicket"
          @onSave="showCreateRepairTicket = false"
          @close="showCreateRepairTicket = false"
        />
      </v-dialog>

      <v-dialog
        v-model="manageDialog"
        width="600"
        persistent
      >
        <create-new-ticket
          v-if="newTicket && manageDialog"
          @onSave="manageDialog = false"
          @close="manageDialog = false"
          :batchMode="true"
        />
      </v-dialog>

      <v-dialog
        v-model="isViewingHelp"
        persistent
        eager
        width="100%"
      >
        <help-topic-viewer class="vh90" />
      </v-dialog>

      <red-alert />

      <presentation
        v-model="showPresentation"
        ref="presentation"
        v-if="getUser && getUser.apitoken && showPresentation"
      />

      <good-news-presentation
        v-model="showBragPresentation"
        v-if="getUser && getUser.apitoken && showBragPresentation"
      />

      <v-dialog
        v-model="isViewingIntroVideo"
        width="80%"
        persistent
      >
        <intro-video-viewer
          class="vh90"
          src="IntrotoAgrifyInsights.mp4"
          @close="isViewingIntroVideo = false"
        />
      </v-dialog>

      <v-menu
        v-if="showPresentationMenu"
        v-model="showPresentationMenu"
        :position-x="contextMenuX"
        :position-y="contextMenuY"
        absolute
        offset-y
        transition="scale-transition"
      >
        <v-card>
          <div
            class="py-2 text-center"
            style="background-color: #1876d2; color: white"
          >
            Select Presentation
          </div>
          <v-divider />
          <v-card-text
            style="height: 100px; overflow-y: hidden"
            class="pt-0"
          >
            <v-list dense>
              <v-list-item
                class="context-action"
                @click="onPresent"
              >
                <v-list-item-title>Facility Status</v-list-item-title>
              </v-list-item>

              <v-list-item
                class="context-action"
                @click="onBrag"
              >
                <v-list-item-title>Global Highlights</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-menu>

      <v-menu
        v-if="showWeeklyReportMenu"
        v-model="showWeeklyReportMenu"
        :position-x="contextMenuX"
        :position-y="contextMenuY"
        absolute
        offset-y
        transition="scale-transition"
      >
        <v-card>
          <div
            class="py-2 text-center"
            style="background-color: #1876d2; color: white"
          >
            Select Report
          </div>
          <v-divider />
          <v-card-text
            style="height: 100px; overflow-y: hidden"
            class="pt-0"
          >
            <v-list dense>
              <v-list-item
                class="context-action"
                @click="onShowFacilityStatusReport"
              >
                <v-list-item-title>Facility Status</v-list-item-title>
              </v-list-item>

              <v-list-item
                class="context-action"
                @click="onShowSampleFacilityStatusReport"
              >
                <v-list-item-title>Mock Report</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-menu>

      <v-dialog
        v-model="showMessageBox"
        persistent
        width="400"
      >
        <v-card v-if="showMessageBox">
          <v-card-title>
            <h2 v-if="showMessageBoxParams.title">
              {{ showMessageBoxParams.title }}
            </h2>
            <v-spacer />
            <v-btn
              icon
              @click="onMessageBoxCancel"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <span v-if="showMessageBoxParams.message">
              {{ showMessageBoxParams.message }}
            </span>
            <v-form
              v-if="showMessageBoxParams.promptFields"
              v-model="promptIsValid"
            >
              <div
                v-for="(field, i) in showMessageBoxParams.promptFields"
                :key="i"
              >
                <v-text-field
                  v-if="field.type === 'text'"
                  :label="field.label"
                  v-model="field.value"
                  :rules="field.rules"
                />
                <v-textarea
                  outlined
                  v-if="field.type === 'textarea'"
                  :label="field.label"
                  v-model="field.value"
                  :rules="field.rules"
                />
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn
              v-if="showMessageBoxParams.action"
              text
              color="primary"
              :disabled="showMessageBoxParams.type === 'prompt' && !promptIsValid"
              @click="onMessageBoxConfirm"
            >
              <span v-if="showMessageBoxParams.action.text">
                {{ showMessageBoxParams.action.text }}
              </span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="snackbar"
        :timeout="snackbarTimeout"
        :color="snackbarColor"
        top
      >
        {{ snackbarMessage }}
        <template v-slot:action="{ attrs }">
          <v-btn
            dark
            text
            v-bind="attrs"
            @click="snackbar = false"
            >Close</v-btn
          >
        </template>
      </v-snackbar>

      <v-snackbar
        v-model="showServiceInterruptBanner"
        :timeout="-1"
        color="warning"
        top
      >
        <span v-html="serviceInterruptMessage"></span>
        <template v-slot:action="{ attrs }">
          <v-btn
            dark
            text
            v-bind="attrs"
            @click="showServiceInterruptBanner = false"
            >Close</v-btn
          >
        </template>
      </v-snackbar>

      <v-dialog
        v-model="showLargeMenu"
        width="90%"
      >
        <full-screen-menu
          :facility-nav-menu="facilityNavMenu"
          class="vh90"
          @close="showLargeMenu = false"
        />
      </v-dialog>

      <delete-modal />
    </div>
  </v-app>
</template>

<script>
import LogRocket from 'logrocket';
import vuetifyToast from '@/vuetifyToast.js';
import moment from 'moment-timezone';
import Trimaster from '@/plugins/servers/trimaster.js';
import LexBot from '@/components/util/LexBot.vue';
import Chat from '@/components/Chat.vue';
import BaseMixin from '@/mixins/base.js';
import FacilityStatus from '@/components/dashboard/components/FacilityStatus.vue';
import { mapGetters, mapActions } from 'vuex';

import Navbar from '@/components/Navbar.vue';
// import ComplianceModal from "@/components/modals/ComplianceModal.vue";
import ServiceLevelAgreementViewer from '@/components/systemadmin/servicelevelAgreements/ServiceLevelAgreementViewer.vue';
import DeleteModal from '@/components/modals/DeleteModal.vue';
import Vue from 'vue';
import CreateNewTicket from './components/servicetickets/CreateNewTicket.vue';
import ReleaseNotesViewer from '@/components/systemadmin/releaseNotes/ReleaseNotesViewer.vue';
import HelpTopicViewer from '@/components/systemadmin/helpTopics/HelpTopicViewer';
import IntroVideoViewer from '@/components/systemadmin/helpTopics/IntroVideoViewer';
import { EventBus } from '@/event-bus.js';
import RedAlert from '@/components/redalert/RedAlert.vue';
import Presentation from '@/components/presentation/Presentation.vue';
import FacilityNewsletter from '@/components/dashboard/components/FacilityNewsletter';
import GoodNewsPresentation from '@/components/presentation/goodnews/GoodNewsPresentation.vue';
import FullScreenMenu from './FullScreenMenu.vue';
import CreateNewRepairTicket from '@/components/repairTickets/CreateNewRepairTicket.vue';

const DEMO_FACILITY = 'DEMO Main Facility';

export default {
  name: 'App',
  mixins: [BaseMixin],
  components: {
    FacilityNewsletter,
    Navbar,
    DeleteModal,
    LexBot,
    Chat,
    FacilityStatus,
    // ComplianceModal,
    ServiceLevelAgreementViewer,
    CreateNewTicket,
    ReleaseNotesViewer,
    HelpTopicViewer,
    RedAlert,
    Presentation,
    GoodNewsPresentation,
    FullScreenMenu,
    IntroVideoViewer,
    CreateNewRepairTicket,
  },

  async beforeMount() {
    this.serviceWorkerRegistration = await navigator.serviceWorker.register('/service-worker.js');
    if (this.serviceWorkerRegistration.waiting) {
      this.invokeServiceWorkerUpdate();
    }

    this.serviceWorkerRegistration.addEventListener('updatefound', () => {
      if (this.serviceWorkerRegistration.installing) {
        // wait until the new Service worker is actually installed (ready to take over)
        this.serviceWorkerRegistration.installing.addEventListener('statechange', () => {
          if (this.serviceWorkerRegistration.waiting) {
            // if there's an existing controller (previous Service Worker), run the update
            if (navigator.serviceWorker.controller) {
              this.invokeServiceWorkerUpdate();
            }
          }
        });
      }
    });

    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!refreshing) {
        // Our service worker code has updated, reload the page to restart the service worker
        window.location.reload();
        refreshing = true;
      }
    });

    // deal with dynamic branding
    let me = this;
    Trimaster.get('apps', null, {
      filter: {
        where: {
          urlSearchString: location.host.split(':')[0],
        },
      },
    }).then(function ([res, err]) {
      if (err) {
        vuetifyToast.error('An error occurred. Please try again later.');
        return;
      }

      if (res.length == 1) {
        document.title = res[0].productName;
        me.copyrightNotice = new Date().getFullYear() + ' ' + res[0].copyright;
        me.branding = res[0];
        me.setFavIcon(res[0].favIconUrl);
        me.setAppleIcons(res[0]);
        me.setIosAppTitle(res[0].productName);
        me.setAppleStartupScreens(res[0]);
      } else {
        (me.branding = {
          productName: 'Agrify Insights',
          loginPageHostCompanyLogoUrl: 'https://agrinamics-training.s3.amazonaws.com/app-loginPageLogo-svg-f9duo7.svg',
          loginPageHostCompanyLogoBgColor: '#0B4119',
          copyright: 'Agrify Corporation',
          idleUserRefresh: 0,
        }),
          (document.title = 'Agrify Insights');
        me.copyrightNotice = new Date().getFullYear() + ' Agrify Corporation. All Rights Reserved.';
        vuetifyToast.error('Could not retrieve branding information.');
      }
    });

    Vue.prototype.$initialViews = [
      {
        id: 1,
        label: 'Owner Dashboard',
        route: 'dashboard/executive',
      },
      {
        id: 2,
        label: 'Facility Manager Dashboard',
        route: 'dashboard/facility',
      },
      {
        id: 3,
        label: 'Farm Manager Dashboard',
        route: 'dashboard/farm',
      },
      {
        id: 4,
        label: 'Your Tasks',
        route: 'taskflowmain',
      },
      {
        id: 5,
        label: 'Device Control',
        route: 'zone-devices/all',
      },
    ];

    if (this.$route.path.substring(1) === 'login') {
      this.activeNav = 'dashboard';
    } else {
      this.activeNav = this.$route.path.substring(1);
    }
    this.changeActiveNav(this.$route.path.substring(1));
    this.$store.dispatch('setSessionStatus');
    if (this.getUser.apitoken) {
      this.facilityClockIntervalId = this.initFacilityClock();
    }
  },
  mounted: function () {
    // This calculates viewport height on mobile devices (iOS toolbar causes problems)
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('orientationchange', this.handleOrientation);

    const vm = this;

    this.onAuthenticated();
    vm.$root.eventHub.$on('update-user-image', (path) => {
      vm.profileImg = path;
    });

    EventBus.$on('present', this.onPresent);
    EventBus.$on('toast', this.showToast);
    EventBus.$on('messagebox', this.onShowMessageBox);
    EventBus.$on('facility-websocket-message', this.handleSocketMessage);

    vm.$root.eventHub.$on('get-facility-nav-menu', () => {
      vm.getFacilityNavMenu();
    });
    if (this.getUser && this.getUser.apitoken && this.getUser.facility_id) {
      this.checkServiceInterrupt();
    }
  },
  beforeDestroy() {
    this.clearIntervals();
    this.$refs.serviceInterruptOverlay.removeEventListener('wheel', this.handelOverlayScroll);
  },
  data() {
    return {
      lastUserAction: null,
      userIdleTimeout: null,
      showFakeNewsletter: false,
      Trimaster: Trimaster,
      showWeeklyReportMenu: false,
      isViewingIntroVideo: false,
      showLargeMenu: false,
      contextMenuX: 0,
      contextMenuY: 0,
      branding: null,
      showPresentationMenu: false,
      showReleaseNotes: false,
      showPresentation: false,
      showBragPresentation: false,
      snackbar: false,
      snackbarMessage: '',
      snackbarColor: '#000000',
      snackbarTimeout: 4000,
      showSla: false,
      currentSla: null,
      showFacilityStatus: false,
      manageDialog: false,
      newTicket: null,
      showCreateRepairTicket: false,
      refreshKey: 0,
      windowHeight: 600,
      showChat: false,
      conversation: {},
      isRecording: false,
      isTrimaster: Trimaster.isTrimaster(),
      facilityNavMenu: {},
      copyrightNotice: '',
      mini: false,
      activeNav: 'dashboard',
      enableTransition: true,
      isMaximized: true,
      facilityLogoSmall: '',
      facilityLogo: '',
      topClock: null,
      facilityClockIntervalId: {},

      isGeneticsOpen: false,
      profileImg: 'https://s3.amazonaws.com/agrinamics-images/logos/profile.png',
      hideFooter: false,
      showMessageBox: false,
      showMessageBoxParams: {
        title: '',
        message: '',
        type: '',
        callback: function () {},
      },
      promptIsValid: false,
      showNewsletter: false,
      secondaryDrawerStatus: false,
      serviceWorkerRegistration: null,
      showServiceInterruptBanner: false,
      serviceInterruptMessage: null,
      showServiceInterruptOverlay: false,
    };
  },
  computed: {
    ...mapGetters([
      'isAuthenticated',
      'getUser',
      'userFacilities',
      'wasLoginSuccessful',
      'currentFacility',
      'facilityData',
      'userData',
      'isViewingHelp',
      'timePreference24Hour',
      'timePreference',
    ]),
    ...mapGetters('socketMessages', ['isConnected']),

    topClockTimeZone() {
      return this.timePreference == 11 ? moment.tz.guess() : this.getUser.facility_timezone;
    },

    on401Page() {
      return this.$route.name === 'page-401';
    },

    filteredUserFacilities() {
      let filteredFacilities = this.userFacilities.filter(
        (facility) => facility.status === 'available' && facility.facility != this.getUser.facilityname
      );
      filteredFacilities.sort(function (a, b) {
        if (a.facility > b.facility) {
          return 1;
        } else {
          return -1;
        }
      });
      return filteredFacilities;
    },

    largeLogo() {
      if (this.branding) {
        return {
          'background-image': 'url(' + this.branding.mainNavigationCompanyLogoUrl + ')',
          'background-size': 'contain',
          'background-repeat': 'no-repeat',
          'background-position': 'center center',
        };
      }
    },

    smallLogo() {
      if (this.branding) {
        return {
          'background-image': 'url(' + this.branding.mainNavigationMiniCompanyLogoUrl + ')',
          'background-size': 'contain',
          'background-repeat': 'no-repeat',
          'background-position': 'center center',
          width: '70px',
        };
      }
    },

    showNavs: function () {
      return (
        this.$route.path === '/login' ||
        this.$route.path === '/setaccount' ||
        this.$route.path === '/passwordrecovery' ||
        this.$route.path === '/notfound' ||
        this.$route.path === '/unauthorized' ||
        this.$route.path === '/passwordreset' ||
        this.$route.name === 'notifications-unsubscribe' ||
        this.$route.name === 'notifications-resolve'
      );
    },
    isLogin: function () {
      if (!this.showNavs) {
        return 'padding-left: 10px; padding-right: 10px';
      } else {
        return '';
      }
    },
    routeToNav() {
      if (this.facilityNavMenu && this.facilityNavMenu.navmenu) {
        const routeToNav = this.facilityNavMenu.navmenu.reduce((result, navItem) => {
          result[navItem.route] = navItem;
          if (navItem.children) {
            navItem.children.forEach((subNavItem) => {
              result[subNavItem.route] = navItem;
            });
          }
          return result;
        }, {});
        routeToNav['/creategrowplan'] = routeToNav['/growplans'];
        routeToNav['/viewgrowplan/id'] = routeToNav['/growplans'];
        routeToNav['/growplan/id'] = routeToNav['/growplans'];

        return routeToNav;
      } else {
        return {};
      }
    },
  },
  methods: {
    ...mapActions([
      'logout',
      'setSessionStatus',
      'getUserFacilities',
      'getFacilityById',
      'getFacilityData',
      'getUserData',
      'setIsViewingHelp',
      'setHelpTopics',
    ]),

    async checkServiceInterrupt() {
      let [facility, err] = await Trimaster.get(`facilities/${this.getUser.facility_id}`, this.getUser.apitoken);
      switch (facility.serviceInterruptLevel) {
        case 1:
          this.serviceInterruptMessage = facility.serviceInterruptMessage;
          this.showServiceInterruptBanner = true;
          break;
        case 2:
          this.serviceInterruptMessage = facility.serviceInterruptMessage;
          this.showServiceInterruptBanner = true;
          if (!Trimaster.isAdmin(this.getUser)) {
            this.showServiceInterruptOverlay = true;
            this.$refs.serviceInterruptOverlay.addEventListener('wheel', this.handelOverlayScroll, { passive: false });
          }
          break;
        case 3:
          break;
      }
    },
    handelOverlayScroll(event) {
      if (event.deltaX !== 0) {
        event.preventDefault();
      }
      this.$store.dispatch('universalDashboard/setOverlayDeltaY', event.deltaY);
      this.$store.dispatch('universalDashboard/setOverlayDeltaX', event.deltaX);
    },

    resetUserIdle() {
      const idleUserRefresh = this.branding.idleUserRefresh;
      if (idleUserRefresh && idleUserRefresh > 0) {
        const now = moment().subtract(idleUserRefresh, 'seconds');
        if (this.lastUserAction && this.lastUserAction.isBefore(now)) {
          window.location.reload();
        } else {
          this.lastUserAction = moment();
        }
      }
    },

    resetUserIdleTimeout() {
      const idleUserRefresh = this.branding.idleUserRefresh;
      if (idleUserRefresh && idleUserRefresh > 0) {
        if (this.userIdleTimeout) {
          clearTimeout(this.userIdleTimeout);
        }
        this.userIdleTimeout = setTimeout(() => {
          window.location.reload();
        }, idleUserRefresh * 1000);
      }
    },

    invokeServiceWorkerUpdate() {
      if (this.serviceWorkerRegistration.waiting) {
        // We have a new version of the service worker code, tell registered instances to update now
        this.serviceWorkerRegistration.waiting.postMessage('SKIP_WAITING');
      }
    },

    handleNavChange(secondaryDrawerStatus) {
      this.secondaryDrawerStatus = secondaryDrawerStatus;
    },

    closeNavbar() {
      if (this.$refs.navbar) {
        this.$refs.navbar.closeNavbar();
      }
    },

    onShowPresentation(event) {
      if (this.getUser.email.indexOf('agrify.com') > 0) {
        let menuHeight = 80;
        let windowHeight = window.innerHeight;
        this.showPresentationMenu = false;
        if (event.clientY + menuHeight > windowHeight) {
          this.contextMenuY = windowHeight - menuHeight - 20;
        } else {
          this.contextMenuY = event.clientY;
        }
        this.contextMenuX = event.clientX;
        this.$nextTick(() => {
          this.showPresentationMenu = true;
        });
      } else {
        this.onPresent();
      }
    },

    onPresent() {
      this.showPresentation = true;
    },

    onBrag() {
      this.showBragPresentation = true;
    },

    onShowNewsletterPopup(event) {
      if (location.hostname.indexOf('dev.agrifyinsights.com') >= 0 || location.hostname.indexOf('localhost') >= 0) {
        let menuHeight = 80;
        let windowHeight = window.innerHeight;
        this.showWeeklyReportMenu = false;
        if (event.clientY + menuHeight > windowHeight) {
          this.contextMenuY = windowHeight - menuHeight - 20;
        } else {
          this.contextMenuY = event.clientY;
        }
        this.contextMenuX = event.clientX;
        this.$nextTick(() => {
          this.showWeeklyReportMenu = true;
        });
      } else {
        this.onShowFacilityStatusReport();
      }
    },

    onShowFacilityStatusReport() {
      this.showFakeNewsletter = false;
      this.showNewsletter = true;
    },

    onShowSampleFacilityStatusReport() {
      this.showFakeNewsletter = true;
      this.showNewsletter = true;
    },

    handleResize() {
      setTimeout(() => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
      }, 500);
    },

    handleOrientation() {
      setTimeout(() => {
        this.hideFooter = window.innerHeight < window.innerWidth;
      }, 500);
    },

    onDisplayReleaseNotes() {
      this.showReleaseNotes = true;
    },

    showToast(color, message, timeout) {
      this.snackbarMessage = message;
      this.snackbarColor = color;
      this.snackbarTimeout = timeout;
      this.snackbar = true;
    },

    handleSocketMessage(message) {
      if (message.type === 'frontendPreferenceUpdated') {
        let preference = message.payload;
        this.$store.dispatch('frontendPreferences/updatePreference', preference);
      } else if (message.type === 'facilityUserLogout') {
        const userIds = message.payload.userIds;
        if (userIds.find((userId) => userId === this.getUser.id)) {
          window.localStorage.clear();
          this.$router.push('/login');
        }
      }
    },

    onShowMessageBox(type, title, message, promptFields, callback) {
      this.showMessageBoxParams = {
        type,
        title,
        message,
        promptFields,
        action: {
          text: type === 'prompt' ? 'Save' : 'Confirm',
          callback,
        },
      };
      this.showMessageBox = true;
    },

    onMessageBoxCancel() {
      if (this.showMessageBoxParams.action.callback) this.showMessageBoxParams.action.callback(false);
      this.showMessageBox = false;
    },

    onMessageBoxConfirm() {
      if (this.showMessageBoxParams.action.callback) this.showMessageBoxParams.action.callback(true);
      this.showMessageBox = false;
    },

    onAuthenticated() {
      if (this.isAuthenticated) {
        let me = this;
        this.$store.dispatch('sensorReadings/loadSensorReadings');
        this.getUserFacilities(this.getUser.apitoken);
        this.getFacilityById({
          apitoken: this.getUser.apitoken,
          facilityId: this.getUser.facility_id,
        });
        this.verifySlaAcknowledgement();

        // this should be changed to use the userpreferences model... DOH
        Trimaster.get('users/' + this.getUser.id, this.getUser.apitoken, {
          filter: {
            fields: ['showIntroVideo'],
          },
        }).then(function ([res, err]) {
          me.isViewingIntroVideo = res.showIntroVideo;
        });
      }
    },

    verifySlaAcknowledgement() {
      let vm = this;
      Trimaster.get('serviceLevelAgreementAcceptances/hasCurrentUserAccepted', this.getUser.apitoken).then(function ([
        res,
        err,
      ]) {
        if (!res.success) {
          vm.currentSla = res.data.sla;
          vm.showSla = true;
        }
      });
    },

    onShowFacilityHealth() {
      this.$refs.facilityStatus.refresh();
      this.showFacilityStatus = true;
    },

    doLogout() {
      if (this.getUser && this.getUser.apitoken) {
        this.$router.push('/login');
        this.logout({ apitoken: this.getUser.apitoken });
        window.localStorage.clear();
      } else {
        window.localStorage.clear();
        this.$router.push('/login');
      }
    },
    onAddNewRepairTicket() {
      this.showCreateRepairTicket = true;
    },
    onSaveNewRepairTicket() {
      this.showCreateRepairTicket = false;
    },
    onAddNewTicket() {
      let result = null;

      if (this.facilityNavMenu && this.facilityNavMenu.navmenu && this.facilityNavMenu.navmenu.length) {
        this.facilityNavMenu.navmenu.forEach((item) => {
          if (item.children && item.children.length) {
            let search = item.children.filter((childrenItem) => {
              return childrenItem.route === this.$route.path;
            });
            if (search.length) {
              result = search[0];
            }
          }
        });
      }

      this.manageDialog = true;
      this.newTicket = {
        ticketStatus_id: '',
        area: result ? result.menuItem : '',
        ticketTypes_id: '',
        description: '',
      };
    },
    //TODO: this goes
    onSaveTicket(rec) {
      this.selectedRec = { ...rec };

      this.$set(this.selectedRec, 'updateuser', `${this.getUser.firstname} ${this.getUser.lastname}`);
      this.$set(this.selectedRec, 'updatedate', new Date().toISOString());

      let me = this;

      Trimaster.patch('software_tickets', this.getUser.apitoken, this.selectedRec).then(function (res) {
        if (res.length == 1) {
          vuetifyToast.success('Ticket Logged');
          me.manageDialog = false;
          me.newTicket = null;
        } else {
          vuetifyToast.error('Error - ' + res[1].message);
        }
      });
    },
    onStartChat() {
      let me = this;
      me.showChat = true;
      setTimeout(function () {
        me.$refs.chat.startRecording();
      }, 500);
    },
    startSpeech() {
      this.isRecording = true;
    },
    getFacilityNavMenu() {
      let me = this;
      Trimaster.get('ag_navigationMenus/getMenuForCurrentUser', this.getUser.apitoken, {
        facility_id: this.getUser.facility_id,
      }).then(function ([res, err]) {
        me.facilityNavMenu = {
          navmenu: res,
        };
      });
    },

    setIosAppTitle(s) {
      let meta = document.createElement('meta');
      meta.name = 'apple-mobile-web-app-title';
      meta.content = s;
      document.getElementsByTagName('head')[0].appendChild(meta);
    },

    setAppleStartupScreens(brandingInfo) {
      let screens = [
        {
          media: '(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3)',
          href: brandingInfo.ios_1242_2688,
        },
        {
          media: '(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2)',
          href: brandingInfo.ios_828_1792,
        },
        {
          media: '(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3)',
          href: brandingInfo.ios_1125_2436,
        },
        {
          media: '(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3)',
          href: brandingInfo.ios_1242_2208,
        },
        {
          media: '(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2)',
          href: brandingInfo.ios_750_1334,
        },
        {
          media: '(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2)',
          href: brandingInfo.ios_2048_2732,
        },
        {
          media: '(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2)',
          href: brandingInfo.ios_1668_2388,
        },
        {
          media: '(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2)',
          href: brandingInfo.ios_1668_2224,
        },
        {
          media: '(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2)',
          href: brandingInfo.ios_1536_2048,
        },
      ];

      for (let i = 0; i < screens.length; i++) {
        if (screens[i].href != null) {
          let l = document.createElement('link');
          l.rel = 'apple-touch-startup-image';
          l.media = screens[i].media;
          l.href = screens[i].href;
          document.getElementsByTagName('head')[0].appendChild(l);
        }
      }
    },

    setAppleIcons(brandingInfo) {
      let icons = [
        {
          sizes: '152x152',
          url: brandingInfo.ios_icon_152_152,
        },
        {
          sizes: '167x167',
          url: brandingInfo.ios_icon_167_167,
        },
        {
          sizes: '180x180',
          url: brandingInfo.ios_icon_180_180,
        },
      ];

      for (let i = 0; i < icons.length; i++) {
        let l = document.createElement('link');
        l.rel = 'apple-touch-icon';
        l.href = icons[i].url;
        l.sizes = icons[i].sizes;
        l.type = 'image/png';
        document.getElementsByTagName('head')[0].appendChild(l);
      }
    },

    setFavIcon(url) {
      var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = url;
      document.getElementsByTagName('head')[0].appendChild(link);
    },

    clearIntervals() {
      clearInterval(this.facilityClockIntervalId);
    },

    initFacilityClock() {
      if (this.getUser.facility_timezone) {
        const userInfo = JSON.parse(window.localStorage.getItem('user'));
        const format = userInfo.timePreference24Hour && userInfo.timePreference24Hour == 14 ? 'HH:mm' : 'h:mm a';
        if (userInfo.timePreference == 11) {
          this.topClock = moment().format(format);
        } else {
          this.topClock = moment().tz(this.getUser.facility_timezone).format(format);
        }
        return setInterval(() => {
          if (this.getUser.apitoken) {
            if (userInfo.timePreference == 11) {
              this.topClock = moment().format(format);
            } else {
              this.topClock = moment().tz(this.getUser.facility_timezone).format(format);
            }
          }
        }, 10000);
      }
    },

    changeActiveNav(newActive, menuType) {
      const newActiveValue = typeof newActive !== 'string' ? newActive.menuItem.toLowerCase() : newActive;
      if (menuType === 'second-level') {
        this.activeNav = newActiveValue;
      }
      if (!newActive.children) {
        this.activeNav = newActiveValue;
      }
    },
    setMaximized($event) {
      // $event.preventDefault();
      let mobileView = this.$vuetify.breakpoint.smAndDown;
      this.$store.dispatch('setDrawer', !mobileView ? null : !this.$store.state.navigation.drawer);
      if (!mobileView) {
        this.isMaximized = !this.isMaximized;
        this.$root.$emit('isMaximized', !this.isMaximized);
      }
    },
    changeFacility(facilityId) {
      const switchFacilityObject = {
        apitoken: this.getUser.apitoken,
        facility_id: facilityId,
      };
      localStorage.removeItem('metrcLicense');
      this.$store.dispatch('switchFacility', switchFacilityObject);
    },
    toggleDropDownMenu(nav) {},
  },

  watch: {
    branding() {
      this.resetUserIdle();
      this.resetUserIdleTimeout();
      window.onload = this.resetUserIdleTimeout;
      window.onmousemove = this.resetUserIdleTimeout;
      window.onmousedown = this.resetUserIdleTimeout;
      window.ontouchstart = this.resetUserIdleTimeout;
      window.onclick = this.resetUserIdleTimeout;
      window.onkeydown = this.resetUserIdleTimeout;
      document.addEventListener('visibilitychange', (event) => {
        if (!document.hidden) this.resetUserIdle();
      });
    },
    'getUser.facility_id': async function (newVal) {
      this.$store.dispatch('socketMessages/createFacilitySocketConnection', newVal);

      if (this.getUser.allowPushNotifications && Notification.permission === 'granted') {
        // Tell our service worker to start listening to websocket messages
        let env = process.env;
        this.serviceWorkerRegistration.active.postMessage({
          action: 'createFacilitySocketConnection',
          payload: {
            baseUrl: env.VUE_APP_trimaster_websockets,
            facilityId: this.getUser.facility_id,
          },
        });
      }
    },
    'getUser.allowPushNotifications': async function (allowPushNotifications) {
      if (allowPushNotifications && Notification.permission === 'granted') {
        // Tell our service worker to start listening to websocket messages
        let env = process.env;
        this.serviceWorkerRegistration.active.postMessage({
          action: 'createFacilitySocketConnection',
          payload: {
            baseUrl: env.VUE_APP_trimaster_websockets,
            facilityId: this.getUser.facility_id,
          },
        });
      } else {
        this.serviceWorkerRegistration.active.postMessage({
          action: 'destroyFacilitySocketConnection',
        });
      }
    },
    wasLoginSuccessful(val) {
      let vm = this;
      if (val) {
        this.getUserFacilities(this.getUser.apitoken);
        this.facilityClockIntervalId = this.initFacilityClock();
        this.verifySlaAcknowledgement();
      }
    },
    routeToNav() {
      let pathWithoutParameters = this.$route.path;
      for (let param in this.$route.params) {
        pathWithoutParameters = pathWithoutParameters.replace(this.$route.params[param], param);
      }
      if (this.routeToNav[pathWithoutParameters]) {
        if (this.routeToNav.hasOwnProperty(pathWithoutParameters)) {
          this.activeNav = this.routeToNav[pathWithoutParameters].menuItem.toLowerCase();
        } else {
          this.activeNav = this.routeToNav[this.$route.path].menuItem.toLowerCase();
        }
        if (this.routeToNav[pathWithoutParameters].children) {
          this.routeToNav[pathWithoutParameters].children.forEach((childNavItem) => {
            if (childNavItem.route === pathWithoutParameters) {
              setTimeout(() => {}, 0);
            }
          });
          setTimeout(() => {
            this.toggleDropDownMenu(this.routeToNav[pathWithoutParameters]);
          }, 0);
        }
      }
    },
    isAuthenticated(val) {
      if (val) {
        setTimeout(() => {
          this.enableTransition = val;
        }, 0);
      } else {
        this.enableTransition = val;
      }

      if (!val && this.$route.path != '/setaccount') {
        this.$router.push('/login');
        this.clearIntervals();
      }

      if (this.$route.path === '/') {
        this.$router.push(this.$root.initialRoute || '/dashboard');
      }
    },

    getUser(val) {
      let me = this;

      if (val && val.apitoken && val.facility_id) {
        this.$store.dispatch('frontendPreferences/load');
        this.$store.dispatch('sensorReadings/loadSensorReadings');
        this.getUserFacilities(this.getUser.apitoken);

        this.getFacilityData({
          apitoken: val.apitoken,
          facility_id: val.facility_id,
        });

        this.getFacilityNavMenu();

        LogRocket.identify(val.email, {
          name: val.firstname + ' ' + val.lastname,
          email: val.email,
        });

        Trimaster.get('ag_helptopics', val.apitoken, {
          filter: {
            order: 'topickey',
          },
        }).then(([res, err]) => {
          this.setHelpTopics(res);
        });

        this.checkServiceInterrupt();
      }

      if (val && val.id) {
        this.getUserData({
          apitoken: val.apitoken,
          id: val.id,
        });

        Trimaster.get(`userPreferences`, val.apitoken, {
          filter: {
            where: {
              user_id: val.id,
              userPreferenceParameter_id: 8,
            },
          },
        }).then(([res, err]) => {
          if (err) return vuetifyToast.error(err);

          if (res && res.length) {
            this.$root.timePreference = `${res[0].userPreferenceValue_id}`;
            let userInfo = JSON.parse(window.localStorage.getItem('user'));
            userInfo.timePreference = `${res[0].userPreferenceValue_id}`;
            window.localStorage.setItem('user', JSON.stringify(userInfo));
            this.$store.commit('ALTER_USER_TIME_PREFERENCE', res[0].userPreferenceValue_id);
          } else {
            this.$root.timePreference = '11';
            let userInfo = JSON.parse(window.localStorage.getItem('user'));
            userInfo.timePreference = '11';
            window.localStorage.setItem('user', JSON.stringify(userInfo));
            this.$store.commit('ALTER_USER_TIME_PREFERENCE', 11);
          }
        });

        Trimaster.get(`userPreferences`, val.apitoken, {
          filter: {
            where: {
              user_id: val.id,
              userPreferenceParameter_id: 9,
            },
          },
        }).then(([res, err]) => {
          if (err) return vuetifyToast.error(err);

          if (res && res.length) {
            let userInfo = JSON.parse(window.localStorage.getItem('user'));
            userInfo.timePreference24Hour = `${res[0].userPreferenceValue_id}`;
            window.localStorage.setItem('user', JSON.stringify(userInfo));
            this.$store.commit('ALTER_USER_24_HOUR_TIME_PREFERENCE', res[0].userPreferenceValue_id);
          } else {
            let userInfo = JSON.parse(window.localStorage.getItem('user'));
            userInfo.timePreference24Hour = '13';
            window.localStorage.setItem('user', JSON.stringify(userInfo));
            this.$store.commit('ALTER_USER_24_HOUR_TIME_PREFERENCE', 13);
          }

          this.clearIntervals();
          this.facilityClockIntervalId = this.initFacilityClock();
        });
      }

      if (val && val.theme) {
        this.$vuetify.theme.dark = val.theme === 'dark';
      }
    },

    timePreference24Hour() {
      this.clearIntervals();
      this.facilityClockIntervalId = this.initFacilityClock();
    },

    timePreference() {
      this.clearIntervals();
      this.facilityClockIntervalId = this.initFacilityClock();
    },

    facilityData(data = {}) {
      if (data.logoSmallUrl) this.facilityLogoSmall = data.logoSmallUrl;
      if (data.logoUrl) this.facilityLogo = data.logoUrl;
      if (!data.logoSmallUrl && !data.logoUrl) {
        if (Trimaster.isTrimaster()) {
          this.facilityLogoSmall = '/img/TrigrowIcon.svg';
          this.facilityLogo = '/img/trigrowsystems-white-h.svg';
        } else {
          this.facilityLogoSmall = 'https://s3.amazonaws.com/agrinamics-images/logos/agrinamincs_min.png';
          this.facilityLogo = 'https://s3.amazonaws.com/agrinamics-images/logos/agrinamics_full_x2.png';
        }
      }
    },
    userData(val) {
      if (val.profileImg && val.profileImg.length) {
        this.profileImg = val.profileImg;
      } else {
        this.profileImg = 'https://s3.amazonaws.com/agrinamics-images/logos/profile.png';
      }
      if (val.theme) {
        this.$vuetify.theme.dark = val.theme === 'dark';
      }
    },
  },
};
</script>

<style lang="scss">
@import '~styles/screen';

.serviceInterruptOverlay {
  z-index: 3;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  opacity: 0.46;
  background-color: rgb(33, 33, 33);
  border-color: rgb(33, 33, 33);
}

html,
body {
  margin: 0;
  height: 100%;
  overflow: hidden;
  position: fixed;
  width: 100%;
}

.appHeight {
  overflow: auto;
}

.noAppHeight {
  height: 100%;
}

.navbar-top {
  float: right !important;
  margin-right: 10px;
}

.sidebar-collapse .v-list__tile__action {
  min-width: 26px;
}

#genetics-arrow {
  transition: transform 0.4s;
}

#genetics-arrow.open {
  transform: rotate(-90deg);
}

.nav.navbar-right > li.logout-button > a:hover {
  color: #522586;
}

.full-screen {
  margin-left: 0px !important;
  // background-color: #2C1F3D;
}

.img-nav-facility {
  width: 100%;
}

.img-nav-logo {
  height: 97%;
}

li.small-logo-item {
  padding: 25px 0px 20px;
  text-align: center;
}

img.img-nav-small-logo {
  width: auto;
  height: 50px;
}

.text-muted.facility-selected {
  color: white;
}

span.text-muted.facility-small-selected {
  color: white;
  padding: 14px 20px 14px 20px;
}

.nav .open > a,
.nav .open > a:hover,
.nav .open > a:focus {
  background: #2c1f3d;
}

.modal-header {
  background: #522586;
  color: white;
}

.modal-header button {
  opacity: 1;
  color: white;
}

.modal-header button:hover {
  opacity: 0.7;
  color: white;
}

.panel.with-nav-tabs .panel-heading {
  padding: 5px 5px 0 5px;
}

.panel.with-nav-tabs .nav-tabs {
  border-bottom: none;
}

.panel.with-nav-tabs .nav-justified {
  margin-bottom: -1px;
}

.clickable-element {
  cursor: pointer;
  cursor: hand;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0;
  /* <-- Apparently some margin are still there even though it's hidden */
}

.clock {
  padding-top: 17px;
  padding-right: 5px;
  font-size: 0.9em;
}

a.router-link-exact-active.router-link-active {
  background-color: #293846;
  color: white;
}

// https://github.com/vuetifyjs/vuetify/issues/4802
.v-dialog {
  background-color: white !important;
}

h2.expandable:hover {
  cursor: pointer !important;
}

.icon-pointer {
  margin-right: 8px;
  font-size: 22px !important;
  cursor: pointer !important;
}

.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin: 0px !important;
}

.mainMenuOpenCloseBtn .v-btn:not(.v-btn--round).v-size--small {
  min-width: 25px;
  padding: 0 8px;
}

.truncateFacilityNameTopMenu {
  width: 186px;

  .v-btn__content {
    display: inline-block;
    font-size: 0.8em;
    width: 105px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.navbar.theme--dark {
  background-color: #1e1e1e;
}
.footer.theme--dark {
  background-color: #1e1e1e;
}
</style>
